/* globals angular */
(function() {
  'use strict';

  function ReceiverPanelCtrl () {}

  angular
    .module('mandaeApp')
    .controller('ReceiverPanelCtrl', ReceiverPanelCtrl);
}());
